import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwgp4bjyhx: FaireProductEntity = {
  token: "p_qwgp4bjyhx",
  type: "product",
  name: "Evil Eye Ring, Greek Jewelry Ring With Eye, Protection Ring, Zircon Ring",
  brandToken: "b_ur24ckegrz",
  brandName: "Evileyefavor",
  imageUrl:
    "https://cdn.faire.com/fastly/3ebfaa31f9c36bdc8988b00f5f5d32d7730d35584cb71f79d2b8985796a9d862.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7eecc3955f9f19007c44db6777c480bd5eb0135435b29890c110bfa2a0da2854.jpeg",
    "https://cdn.faire.com/fastly/38057277af92836131a104aea20a30bb40f6d4cb1a527c83519dd706bed461be.jpeg",
    "https://cdn.faire.com/fastly/c660ddeec6a3ba2d8eb6c4978fd616e77adc7b44bbbf0a27cb19d946edd7a0e8.jpeg",
    "https://cdn.faire.com/fastly/73c9a28f13d82e3e10114b1a387da314316f5863e6502f7c86a19c9d521c20bb.jpeg",
    "https://cdn.faire.com/fastly/9667a26a187a410db026d1a956873bf53f4a40835a1077c02c77558c47392005.jpeg",
    "https://cdn.faire.com/fastly/daaaead2422e7b4bbb1a84fa70f99009ea9922b785af1efcf6e3dff752310bb1.jpeg",
  ],
  priceDollars: 11.85,
  description:
    'Evil Eye Ring, Greek Jewelry Ring with Eye, Protection Ring, Zircon Ring, Positive Energy Ring, Blue Ring, Protection Ring🌟 These rings are totally handmade in 3 different band colors. Please choose color during checkout;- Gold- Silver- Rose Gold🌟 All parts are nickel free &"; antiallergic. (Not suggest to use under hot water &" sea) 🌟 These are adjustable rings with zircon charms. 🧿 Please check below link to find more handmade rings here";"""',
  tags: [],
  msrpDollars: 19.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:41.978Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
